import { SET_SORT_FOCUS } from "../constants";

export const setSortFocus = focus => dispatch => {
  dispatch({ type: SET_SORT_FOCUS, payload: { focus } });
};
